import Vue from 'vue'
import Router from 'vue-router'
import YDUI from 'vue-ydui' /* 相当于import YDUI from 'vue-ydui/ydui.rem.js' */
import 'vue-ydui/dist/ydui.rem.css'
import HelloWorld from '@/components/HelloWorld'
import global_ from '@/components/Global.vue'

Vue.use(Router)
Vue.use(YDUI)
Vue.prototype.GLOBAL = global_


export default new Router({
  routes: [
  	{
      path: '/',
      name: 'login',
      component: resolve => require(['@/view/login.vue'], resolve),
      meta: {
        title: '注册登录'
      }
    },
    {
      path: '/myactive',
      name: 'myactive',
      component: resolve => require(['@/view/myactive.vue'], resolve),
      meta: {
        title: '我的活动'
      }
    },
    {
      path: '/activeshow',
      name: 'activeshow',
      component: resolve => require(['@/view/activeshow.vue'], resolve),
      meta: {
        title: '活动详情'
      }
    },
    {
      path: '/newsshow',
      name: 'newsshow',
      component: resolve => require(['@/view/newsshow.vue'], resolve),
      meta: {
        title: '新闻详情'
      }
    },
    {
      path: '/main',
      name: 'main',
      component: resolve => require(['@/view/main.vue'], resolve),
      meta: {
        title: '首页'
      }
    },
    {
      path: '/phone_docternews',
      name: 'docternews',
      component: resolve => require(['@/view/phone_docternews.vue'], resolve),
      meta: {
        title: '志愿医生新闻'
      }
    },
    {
      path: '/phone_register',
      name: 'docter_register',
      component: resolve => require(['@/view/phone_register.vue'], resolve),
      meta: {
        title: '志愿医生信息相关记录'
      }
    },
    {
      path: '/upfileupload',
      name: 'upfileupload',
      component: resolve => require(['@/view/upfileupload.vue'], resolve),
      meta: {
        title: '修改个人资料'
      }
    },
    {
      path: '/upbase',
      name: 'upbase',
      component: resolve => require(['@/view/upbase.vue'], resolve),
      meta: {
        title: '修改基本信息'
      }
    },
    {
      path: '/upcert',
      name: 'upcert',
      component: resolve => require(['@/view/upcert.vue'], resolve),
      meta: {
        title: '修改证书'
      }
    },
    {
      path: '/base',
      name: 'base',
      component: resolve => require(['@/view/base.vue'], resolve),
      meta: {
        title: '基本信息填写'
      }
    },
    {
      path: '/upeducation',
      name: 'upeducation',
      component: resolve => require(['@/view/upeducation.vue'], resolve),
      meta: {
        title: '修改教育经历'
      }
    },
    {
      path: '/upwork',
      name: 'upwork',
      component: resolve => require(['@/view/upwork.vue'], resolve),
      meta: {
        title: '修改工作经历'
      }
    },
    {
      path: '/detail',
      name: 'detail',
      component: resolve => require(['@/view/detail.vue'], resolve),
      meta: {
        title: '个人中心'
      }
    },
    {
      path: '/send',
      name: 'send',
      component: resolve => require(['@/view/send.vue'], resolve),
      meta: {
        title: '提交审核'
      }
    },
    {
      path: '/addwork',
      name: 'addwork',
      component: resolve => require(['@/view/addwork.vue'], resolve),
      meta: {
        title: '添加工作经历'
      }
    },
    {
      path: '/addcert',
      name: 'addcert',
      component: resolve => require(['@/view/addcert.vue'], resolve),
      meta: {
        title: '添加证书'
      }
    },
    {
      path: '/addeducation',
      name: 'addeducation',
      component: resolve => require(['@/view/addeducation.vue'], resolve),
      meta: {
        title: '添加教育经历'
      }
    },
    {
      path: '/fileupload',
      name: 'fileupload',
      component: resolve => require(['@/view/fileupload.vue'], resolve),
      meta: {
        title: '个人资料上传'
      }
    },
    {
      path: '/regist',
      name: 'regist',
      component: resolve => require(['@/view/regist.vue'], resolve),
      meta: {
        title: '个人信息注册'
      }
    },
    {
      path: '/education',
      name: 'education',
      component: resolve => require(['@/view/education.vue'], resolve),
      meta: {
        title: '教育经历列表'
      }
    },
    {
      path: '/work',
      name: 'work',
      component: resolve => require(['@/view/work.vue'], resolve),
      meta: {
        title: '工作经历列表'
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js